import React from 'react';
import Modal from '@common/modal';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import classnames from 'classnames/bind';
import styles from './welfareModal.module.scss';
const cx = classnames.bind(styles);

interface WelfareModalProps {
  positionDetail: PositionDetailVO;
  visible: boolean;
  onClose: () => void;
}

const WelfareModal = ({ positionDetail, visible, onClose }: WelfareModalProps) => {
  const { additionalInfo } = positionDetail;

  const welfareEls = additionalInfo.welfareWithCategories?.map((category, i) => {
    const welfareListEls = category.welfares?.map((welfare, i) => {
      return (
        <li key={i} className={cx('listItem')}>
          {welfare}
        </li>
      );
    });

    return (
      <div key={i} className={cx('welfareWrap')}>
        <div className={cx('welfareTitle')}>{category.name}</div>
        <ul className={cx('welfareList')}>{welfareListEls}</ul>
      </div>
    );
  });

  return (
    <Modal visible={visible} dimmed={true}>
      <div className={cx('welfareLayer')}>
        <em className={cx('title')}>이런 복지들이 있어요.</em>

        <div className={cx('scrollArea')}>
          <div className={cx('scrollInner')}>{welfareEls}</div>
        </div>

        <a className={cx('btnClose')} role="button" onClick={onClose}>
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default WelfareModal;
